// hx header (snippets/hx-header.liquid): floating glass capsule. Sliding pill, fold-out clothes panel, phone menu
// with circle reveal, scroll-aware compact/hide + progress line, sun/moon toggle (drives the theme's own toggle),
// cart icon opens Dawn's cart drawer and mirrors its count, and a one-time logo intro (first visit per browser).
(function () {
  const hx = document.querySelector('[data-hx]');
  if (!hx) return;
  const menu = document.getElementById('HxMenu');
  hx.querySelectorAll('.hx__nav > *, .hx__tools > *').forEach((el) => el.style.setProperty('--n', [...el.parentElement.children].indexOf(el)));

  // cart: open the drawer (cart page as fallback) and keep the count in sync with Dawn's hidden bubble
  const cartBtn = hx.querySelector('[data-hx-cart]');
  const count = hx.querySelector('[data-hx-count]');
  cartBtn.addEventListener('click', (e) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    e.preventDefault();
    drawer.open(cartBtn);
  });
  const bubble = document.getElementById('cart-icon-bubble');
  let syncT = 0;
  const syncCount = () => {
    // a paw is flying to the bag (ht.js "Add to cart"): the number changes when it lands
    const wait = (window.htFlyUntil || 0) - 140 - performance.now();
    if (wait > 0) { clearTimeout(syncT); syncT = setTimeout(syncCount, wait); return; }
    const n = parseInt(((bubble && bubble.querySelector('.cart-count-bubble span[aria-hidden]')) || {}).textContent, 10) || 0;
    const changed = String(n) !== count.textContent;
    count.textContent = n; count.hidden = n === 0;
    if (changed && n > 0) { count.classList.remove('is-bump'); void count.offsetWidth; count.classList.add('is-bump'); }
  };
  if (bubble) new MutationObserver(syncCount).observe(bubble, { childList: true, subtree: true, characterData: true });

  // language: the phone menu chip submits the same localization form as the desktop button
  // Fast path: go straight to the page's own other-language address (Shopify lists it as <link rel="alternate" hreflang>)
  // instead of POSTing the form and waiting for a redirect; prefetched on hover/touch. The form stays as the fallback.
  const langForm = hx.querySelector('[data-hx-lang]');
  const langUrl = () => {
    const code = langForm && langForm.querySelector('[name="language_code"]').value;
    const alt = code && document.querySelector(`link[rel="alternate"][hreflang="${code}"]`);
    if (!alt) return null;
    const u = new URL(alt.href, location.href);
    u.search = location.search; u.hash = location.hash;
    // an open Birthday Club invitation (?club_invite was removed from the address bar) travels to the other language
    const inv = document.querySelector('[data-ht-club-form][data-invite]');
    if (inv) u.searchParams.set('club_invite', inv.dataset.invite);
    return u.href;
  };
  let prefetched = false;
  const prefetchLang = () => {
    const href = !prefetched && langUrl();
    if (!href) return;
    prefetched = true;
    const l = document.createElement('link'); l.rel = 'prefetch'; l.href = href; document.head.appendChild(l);
  };
  const switchLang = (e, btn) => {
    if (!langForm) return;
    const href = langUrl();
    try { localStorage.setItem('ht-lang', langForm.querySelector('[name="language_code"]').value); } catch (err) {}  // a manual choice always wins
    if (e) e.preventDefault();
    if (btn) btn.classList.add('is-busy');
    if (href) location.href = href; else langForm.submit();
  };
  const langBtns = [...hx.querySelectorAll('.hx__lang'), ...menu.querySelectorAll('[data-hx-lang-btn]')];
  langBtns.forEach((b) => ['pointerenter', 'touchstart', 'focus'].forEach((ev) => b.addEventListener(ev, prefetchLang, { passive: true })));
  if (langForm) langForm.addEventListener('submit', (e) => switchLang(e, langForm.querySelector('.hx__lang')));
  menu.querySelectorAll('[data-hx-lang-btn]').forEach((b) => b.addEventListener('click', (e) => switchLang(e, b)));


  // Intro, first page of the first visit only, remembered in localStorage (?intro=1 replays, ?ht_reset=1 forgets). The real logo, in four beats:
  //  C  the original stacked logo (Mr Hound above the lettering) in a big circle;
  //  P  Mr Hound slides up out of the circle, the lettering rises to the middle, the circle becomes a pill;
  //  G  the glass bar grows out and carries the pill to the left;
  //  F  the pill widens, the lettering moves right and Mr Hound rises from below into his spot.
  let intro = false;
  try { intro = !localStorage.getItem('hx-intro') && !sessionStorage.getItem('hx-intro') && !matchMedia('(prefers-reduced-motion: reduce)').matches; localStorage.setItem('hx-intro', '1'); } catch (e) {}
  if (new URLSearchParams(location.search).has('intro')) intro = true;
  if (intro) {
    const brand = hx.querySelector('.hx__brand');
    const mark = brand.querySelector('.hx__mark');
    const head = brand.querySelector('.hx__head');
    const word = brand.querySelector('.hx__lettering');
    const ready = [head, word].map((i) => (i.complete ? Promise.resolve() : new Promise((r) => i.addEventListener('load', r, { once: true }))));
    Promise.all(ready).then(() => {
      const cs = getComputedStyle(brand);
      const pl = parseFloat(cs.paddingLeft), pr = parseFloat(cs.paddingRight), pt = parseFloat(cs.paddingTop);
      const mw = mark.offsetWidth, mh = mark.offsetHeight;          // final mark size
      const bw = brand.offsetWidth, bh = brand.offsetHeight;        // final plate size
      const F = { head: [0, 0, mw * 596 / 1293, mh], word: [mw * 476 / 1293, mh * 90 / 600, mw * 817 / 1293, mh * 491 / 600] };
      const D = innerWidth < 990 ? 90 : 136;                        // circle diameter
      const hC = D * 0.42, hW = hC * 596 / 600, wW = D * 0.64, wH = wW * 491 / 817;
      const top0 = (D - (hC + wH - D * 0.03)) / 2;
      const C = { head: [D * 0.5 - hW * 0.36 - (D - mw) * 0, top0, hW, hC], word: [(D - wW) / 2, top0 + hC - D * 0.03, wW, wH] };
      const pillW = F.word[2] + pr * 2;
      const P = { word: [pr, (bh - F.word[3]) / 2, F.word[2], F.word[3]] };
      const box = (el, [x, y, w, h]) => Object.assign(el.style, { left: `${x}px`, top: `${y}px`, width: `${w}px`, height: `${h}px` });
      const plate = (w, h, r) => Object.assign(brand.style, { width: `${w}px`, height: `${h}px`, borderRadius: r, padding: '0' });
      // children are positioned in plate coordinates during the intro
      mark.style.position = 'static';
      hx.style.setProperty('--hx-D', `${D}px`);
      hx.classList.add('is-intro', 'is-c', 'hx-instant');
      plate(D, D, '50%'); box(head, C.head); box(word, C.word);
      hx.style.width = `${D}px`;
      brand.getBoundingClientRect();
      hx.classList.remove('hx-instant');
      brand.animate([{ transform: 'scale(.45)', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }], { duration: 560, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      const at = (ms, fn) => setTimeout(fn, ms);
      at(800, () => {                                               // P
        hx.classList.replace('is-c', 'is-p');
        plate(pillW, bh, '999px');
        hx.style.width = `${pillW}px`;
        box(head, [C.head[0], -C.head[3] - 10, C.head[2], C.head[3]]);
        box(word, P.word);
      });
      at(1350, () => {                                              // G
        hx.classList.replace('is-p', 'is-g');
        hx.style.width = '';
        hx.classList.add('hx-instant-head');
        box(head, [0 + pl, bh + 4, F.head[2], F.head[3]]);          // park Mr Hound below, out of sight
        head.getBoundingClientRect();
        hx.classList.remove('hx-instant-head');
      });
      at(1900, () => {                                              // F
        plate(bw, bh, '999px');
        box(word, [pl + F.word[0], pt + F.word[1], F.word[2], F.word[3]]);
        box(head, [pl + F.head[0], pt + F.head[1], F.head[2], F.head[3]]);
      });
      at(2600, () => {                                              // hand back to the normal CSS layout
        hx.classList.add('hx-instant');
        hx.classList.remove('is-intro', 'is-g');
        ['width', 'height', 'borderRadius', 'padding'].forEach((k) => { brand.style[k] = ''; });
        [head, word].forEach((el) => ['left', 'top', 'width', 'height'].forEach((k) => { el.style[k] = ''; }));
        mark.style.position = '';
        brand.getBoundingClientRect();
        hx.classList.remove('hx-instant');
      });
    });
  }

  // sliding pill follows the hovered / open nav item
  const nav = hx.querySelector('.hx__nav');
  const pill = hx.querySelector('.hx__pill');
  const moveTo = (el) => { if (!el) return; pill.style.width = `${el.offsetWidth}px`; pill.style.transform = `translateX(${el.offsetLeft}px)`; };
  nav.querySelectorAll('a, button').forEach((el) => el.addEventListener('mouseenter', () => moveTo(el)));
  const here = [...nav.querySelectorAll('a')].find((a) => !a.hash && a.pathname === location.pathname);
  if (here) { moveTo(here); pill.style.opacity = '1'; }
  nav.addEventListener('mouseleave', () => { if (!hx.classList.contains('is-panel')) moveTo(here); });

  // clothes panel
  const pBtn = hx.querySelector('[data-hx-panel]');
  const setPanel = (on) => { hx.classList.toggle('is-panel', on); nav.classList.toggle('has-open', on); pBtn.setAttribute('aria-expanded', String(on)); if (on) moveTo(pBtn); };
  pBtn.addEventListener('click', () => setPanel(!hx.classList.contains('is-panel')));
  // leaving the header closes the panel after a short grace, so a quick or slightly off-course mouse doesn't lose it
  let panelT;
  hx.addEventListener('mouseleave', () => { clearTimeout(panelT); panelT = setTimeout(() => setPanel(false), 400); });
  hx.addEventListener('mouseenter', () => clearTimeout(panelT));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { setPanel(false); setMenu(false); } });

  // mode: drive the theme's own toggle so the choice is shared
  hx.querySelector('.hx__mode').addEventListener('click', () => { const t = document.querySelector('.ht-mode-toggle'); if (t) t.click(); });

  // phone menu: circle reveal from the burger
  const burger = hx.querySelector('.hx__burger');
  const setMenu = (on) => {
    // nothing to do when it is already in that state: Esc on any other overlay (pickup sheet, size finder...) must not
    // touch the page scroll lock that the cart drawer below it still holds
    if (hx.classList.contains('is-menu') === on) return;
    const r = burger.getBoundingClientRect();
    menu.style.setProperty('--hx-x', `${r.left + r.width / 2}px`);
    menu.style.setProperty('--hx-y', `${r.top + r.height / 2}px`);
    hx.classList.toggle('is-menu', on);
    hx.classList.remove('is-hidden');
    burger.setAttribute('aria-expanded', String(on));
    menu.setAttribute('aria-hidden', String(!on));
    document.body.classList.toggle('overflow-hidden', on);   // the shared scroll lock in ht.js picks this up
    // the open menu covers the page: keep Tab inside the header + menu (the page underneath is inert meanwhile)
    if (on) {
      inerted = [...document.body.children].filter((el) => el !== hx && el !== menu && !el.inert && !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName));
      inerted.forEach((el) => { el.inert = true; });
    } else {
      inerted.forEach((el) => { el.inert = false; });
      inerted = [];
    }
  };
  let inerted = [];
  burger.addEventListener('click', () => setMenu(!hx.classList.contains('is-menu')));

  // Quick smooth scroll (ease-out, ~0.3-0.65 s; instant with "reduce motion"). Used by the logo (to the top on the
  // home page) and by links to a section on the same page, e.g. Szülinapi Klub -> #birthday-club, instead of a reload/jump.
  const trim = (p) => p.replace(/\/$/, '') || '/';
  let topRaf = 0;
  const stopTop = () => { cancelAnimationFrame(topRaf); topRaf = 0; };
  ['wheel', 'touchstart', 'keydown'].forEach((ev) => window.addEventListener(ev, stopTop, { passive: true }));
  const quickScroll = (to) => {
    const y0 = window.scrollY;
    const dist = to - y0;
    if (Math.abs(dist) < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, to); return; }
    const dur = Math.min(650, 280 + Math.abs(dist) / 12);
    const t0 = performance.now();
    stopTop();
    const step = (now) => {
      const k = Math.min(1, (now - t0) / dur);
      window.scrollTo(0, Math.round(y0 + dist * (1 - Math.pow(1 - k, 3))));   // fast start, soft landing
      topRaf = k < 1 ? requestAnimationFrame(step) : 0;
    };
    topRaf = requestAnimationFrame(step);
  };
  const samePage = (a) => a && !a.target && a.origin === location.origin && trim(a.pathname) === trim(location.pathname);
  const home = hx.querySelector('.hx__brand');
  home.addEventListener('click', (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button || !samePage(home)) return;
    e.preventDefault();
    if (hx.classList.contains('is-menu')) setMenu(false);
    quickScroll(0);
  });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button || !samePage(a) || a.hash.length < 2) return;
    let el = null;
    try { el = document.querySelector(a.hash); } catch (err) {}
    if (!el) return;
    e.preventDefault();
    const go = () => quickScroll(Math.max(0, el.getBoundingClientRect().top + window.scrollY - (hx.querySelector('.hx__bar').offsetHeight + 28)));
    // from the phone menu: close it first (its own click handler may already have), then scroll once the page lock lifts
    if (hx.classList.contains('is-menu') || a.closest('#HxMenu')) { setMenu(false); requestAnimationFrame(() => requestAnimationFrame(go)); }
    else go();
    history.replaceState(null, '', a.hash);
  });
  menu.addEventListener('click', (e) => { if (e.target.closest('a')) setMenu(false); });

  // scroll: compact after 60px, hide on the way down, show on the way up, progress line
  let last = window.scrollY;
  let ticking = false;
  const onScroll = () => {
    const y = window.scrollY;
    const max = document.documentElement.scrollHeight - innerHeight;
    hx.style.setProperty('--hx-p', max > 0 ? (y / max).toFixed(3) : 0);
    hx.classList.toggle('is-compact', y > 60);
    if (!hx.classList.contains('is-menu') && !hx.classList.contains('is-panel')) {
      if (y > last + 6 && y > 220) hx.classList.add('is-hidden');
      else if (y < last - 6 || y < 220) hx.classList.remove('is-hidden');
    }
    last = y;
    ticking = false;
    // pause the floating side balls while the page moves (see ht.css "Smooth scrolling")
    document.documentElement.classList.add('is-scrolling');
    clearTimeout(scrollT);
    scrollT = setTimeout(() => document.documentElement.classList.remove('is-scrolling'), 200);
  };
  let scrollT;
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  // Page transitions (ht.css @view-transition): the header is its own layer so it stays put while the page crossfades.
  // Leaving the page from an overlay that covers the header (cart drawer, pickup sheet, a dialog, the filter drawer)
  // would show the header above it for a moment, so those navigations skip the transition.
  window.addEventListener('pageswap', (e) => {
    if (e.viewTransition && document.querySelector('cart-drawer.active, .mpl-sheet.is-open, dialog[open], .mobile-facets__disclosure[open], .ht-fit__diagram.is-zoomed')) e.viewTransition.skipTransition();
  });
})();
